/**
 * The six default avatar backgrounds for a fan with no photo (SNGL-7360), in place of the gray
 * silhouette. Order matters: a fan's gradient is its index here, so reordering or inserting one
 * recolours everyone — only ever append.
 */
const AVATAR_GRADIENTS = [
  'linear-gradient(315deg, #d53369 0%, #daae51 100%)',
  'linear-gradient(315deg, #FC466B 0%, #3F5EFB 100%)',
  'linear-gradient(315deg, #4b6cb7 0%, #182848 100%)',
  'linear-gradient(315deg, #9ebd13 0%, #008552 100%)',
  'linear-gradient(315deg, #00d2ff 0%, #3a47d5 100%)',
  'linear-gradient(315deg, #00b2c6 0%, #00852a 100%)',
];

// a 50% white wash between the gradient and the white silhouette drawn over it
const AVATAR_OVERLAY = 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5))';

/**
 * The default avatar background for a community user: their gradient under a 50% white overlay, as
 * a CSS `background` value. The gradient is worked out from their id rather than stored, so a fan
 * gets the same one on every surface, session and device, and existing fans get one too. Pass the
 * community user id: `User.id`, or `Author.userId` on a fan submission's byline — the same value.
 */
export function avatarGradient(userId: string): string {
  // FNV-1a: cheap, and spreads uuids evenly across the six
  let hash = 0x811c9dc5;
  for (let i = 0; i < userId.length; i++) {
    hash ^= userId.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  // backgrounds stack first-on-top: the overlay, then the gradient beneath it
  return `${AVATAR_OVERLAY}, ${AVATAR_GRADIENTS[(hash >>> 0) % AVATAR_GRADIENTS.length]}`;
}
